function SectionHeader({ eyebrow, title, sub, align = "center" }) {
  const isCenter = align === "center";
  return (
    <div
      className={`flex flex-col gap-2 ${isCenter ? "items-center text-center" : "items-start text-left"} max-w-2xl ${
        isCenter ? "mx-auto" : ""
      }`}
    >
      <div className="font-mono text-[11px] tracking-[0.18em] text-darkrock/50 uppercase">{eyebrow}</div>
      <h2
        className="iv1-font-display text-3xl sm:text-4xl font-bold text-darkrock leading-tight"
        style={{ textWrap: "balance" }}
      >
        {title}
      </h2>
      {sub && (
        <p className="text-darkrock/70 text-base sm:text-lg" style={{ textWrap: "pretty" }}>
          {sub}
        </p>
      )}
    </div>
  );
}

export default SectionHeader;
